import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD;
}

export default GravelRoadTileEntity;
